import { render } from "./VerifDialog.vue?vue&type=template&id=20a956d2&scoped=true"
import script from "./VerifDialog.vue?vue&type=script&lang=js"
export * from "./VerifDialog.vue?vue&type=script&lang=js"

import "./VerifDialog.vue?vue&type=style&index=0&id=20a956d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a956d2"]])

export default __exports__